// extracted by mini-css-extract-plugin
export default {"container":"About_container__63eab","info":"About_info__Sv-9g"};